import _ from 'lodash';

const config = require(
  `../../../@${process.env.REACT_APP_TENANT}/config.js`
).default;

const allCommands = (app, store, t) => {
  const { cmdBar, round } = store;
  return [
    {
      key: 'bidding-history',
      name: t('All offers'),
      iconProps: {
        iconName: 'NumberedList',
      },
      iconOnly: true,
      onClick: () => store.ui.showBiddingHistory(),
      disabled: !store.round.isOpenBidding,
    },
    // DAV-814: This is hidden as users try to start 2nd round here instead of wizard which results in a messed up round
    // {
    //   key: 'start',
    //   name: t('New'),
    //   iconProps: {
    //     iconName: 'CirclePlus',
    //   },
    //   iconOnly: true,
    //   onClick: () => store.ui.startRound(),
    //   disabled: !cmdBar.roundStartEnabled,
    // },
    {
      key: 'edit',
      name: t('Edit'),
      iconProps: {
        iconName: 'CirclePlus',
      },
      iconOnly: true,
      onClick: () => store.ui.startRound(),
      disabled: !cmdBar.roundEditEnabled,
    },
    {
      key: 'open',
      name: t('Open'),
      iconProps: {
        iconName: 'MSNVideos',
      },
      iconOnly: true,
      onClick: () =>
        store.ui.prompt.open({
          title: t('Round open'),
          action: () => store.round.open(),
          content: 'openRound',
        }),
      disabled: !cmdBar.roundOpenEnabled,
    },
    {
      key: 'stop',
      name: t('Round close'),
      iconProps: {
        iconName: 'CircleStop',
      },
      iconOnly: true,
      onClick: () =>
        store.ui.prompt.open({
          title: t('End round early'),
          message:
            round.type === 'sealed_bidding'
              ? t(`are_you_sure_to_end_round_early_sealed`)
              : t(`are_you_sure_to_end_round_early`),
          action: () => store.round.close(),
        }),
      disabled: !cmdBar.roundCloseEnabled,
    },
  ].filter(Boolean);
};

const roundCommandItems = (app, store, t) => {
  return [
    {
      key: 'round',
      name: t('Round'),
      subMenuProps: {
        items: _.filter(allCommands(app, store, t), (item) =>
          config.roundCommands.includes(item.key)
        ),
      },
    },
  ];
};

export { roundCommandItems };



// WEBPACK FOOTER //
// ./src/app/containers/Sale/Commands/roundCommandItems.js